import {
  call, put, select, takeEvery, takeLeading,
} from 'redux-saga/effects';
import findResult from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import selectors from '@/selectors';
import callAdapter from '@/utils/sagaHelper';
import { applyRoleActions } from '@/users/actions';
import RoleActionsService from '../service';
import {
  fetchRoleActionsError,
  fetchRoleActionsSuccess,
  showRoleActions,
  updateRoleActionsError,
  updateRoleActionsSuccess,
} from '../actions';
import actions from '../constants';
import { newRoleError } from '../../actions';

function* applyRoleActionsToCurrentRole(code, roleActions) {
  const auth = yield select(selectors.auth);

  if (auth.role.code === code) {
    yield put(applyRoleActions(roleActions));
  }
}

export function* fetch({ code, category, showDialog }) {
  const { response, error } = yield call(callAdapter, RoleActionsService.get(code));

  if (error) {
    yield put(fetchRoleActionsError(code, category, error));
  } else {
    yield put(fetchRoleActionsSuccess(code, category, response));
    if (showDialog) {
      yield put(showRoleActions(code, category, response.items, states.SUCCESS));
    }
  }
}

export function* refresh({ code }) {
  const { response, error } = yield call(callAdapter, RoleActionsService.get(code));

  if (!error) {
    yield applyRoleActionsToCurrentRole(code, response.items);
  }
}

export function* update({ category, code }) {
  const items = yield select(selectors.roles);
  const { roleActions } = yield select(selectors.activeRoleActions);
  const role = findResult(items, category, code);

  const { response, error } = yield call(callAdapter, RoleActionsService.update(code, roleActions));
  if (error) {
    yield put(updateRoleActionsError(code, category, error));
  } else {
    yield put(updateRoleActionsSuccess(code, category, response, role));
    yield applyRoleActionsToCurrentRole(code, response.items);
  }
}

export function* duplicateRoleActions(codeFrom, codeTo) {
  const { response, error } = yield call(callAdapter, RoleActionsService.get(codeFrom));

  if (error) {
    yield put(newRoleError(error));
    return;
  }

  const roleActionsNames = response.items.map(({ name }) => name);
  const updateResult = yield call(callAdapter, RoleActionsService.update(codeTo, roleActionsNames));
  if (updateResult.error) {
    yield put(newRoleError(updateResult.error));
  }
}

export default function* roleActionsApi() {
  yield takeEvery(actions.FETCH_ROLE_ACTIONS, fetch);
  yield takeEvery(actions.REFRESH_ROLE_ACTIONS, refresh);
  yield takeLeading(actions.UPDATE_ROLE_ACTIONS, update);
}
